var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCampaignButtons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 925.541,
    height: 275.918,
    viewBox: "0 0 925.541 275.918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        opacity: 0.6;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n        stroke: #0cf;\r\n      }\r\n\r\n      .cls-3 {\r\n        filter: url(#Trazado_220);\r\n      }\r\n\r\n      .cls-4 {\r\n        filter: url(#Trazado_218);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_218",
    x: 0.5,
    y: 0.5,
    width: 924.541,
    height: 274.918,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_220",
    x: 0,
    y: 0,
    width: 925.541,
    height: 275.918,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_campaign_buttons",
    transform: "translate(23 23)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4",
    transform: "matrix(1, 0, 0, 1, -23, -23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_218-2",
    "data-name": "Trazado 218",
    className: "cls-1",
    d: "M1511.338,1058.288H664.363L631.8,1091.776v196.431h846.975l32.566-33.487Z",
    transform: "translate(-608.8 -1035.29)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3",
    transform: "matrix(1, 0, 0, 1, -23, -23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_220-2",
    "data-name": "Trazado 220",
    className: "cls-2",
    d: "M1511.338,1058.288H664.363L631.8,1091.776v196.431h846.975l32.566-33.487Z",
    transform: "translate(-608.8 -1035.29)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignButtons);
export default __webpack_public_path__ + "static/media/campaign_buttons.c128fb4037cee87cb62672ff1a6ddc09.svg";
export { ForwardRef as ReactComponent };